import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { environment } from '@environments/environment';
import { IPagingResponse, IResponse } from '@shared/models';
import { NotificationQuery } from '@shared/models/notification-query';

export enum SystemNotificationGroup {
  DataTemplate = 1,
  DataRequest = 2,
  QuestionnaireRequest = 3,
}

export interface SystemNotification {
  id: number;
  subject: string;
  description: string;
  createdDate: string;
  groupId: SystemNotificationGroup;
  entityId: number;
  isRead: boolean;
  unreadNotificationsCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class SystemNotificationsService {
  private readonly url = environment.apiBaseUrl + 'api/Notifications';
  private readonly http = inject(HttpClient);

  refresher$ = new BehaviorSubject<void>(void 0);

  getByQuery(query: NotificationQuery) {
    const params = { ...query };
    return this.http
      .get<IPagingResponse<SystemNotification>>(this.url, {
        params,
      });
  }

  markAllAsRead() {
    return this.http.put<IResponse<unknown>>(`${this.url}/markAsRead`, {}).pipe(tap(() => this.refresher$.next()));
  }

  markAsRead(id: number) {
    return this.http
      .put<IResponse<unknown>>(`${this.url}/${id}/markAsRead`, {})
      .pipe(tap(() => this.refresher$.next()));
  }
}
